import { useField } from "formik";
import React from "react";

type RadioProps = {
    setValue: (name: string, value: number | null) => void;
    name: string;
    label: string;
    value: number;
};
const Radio = (props: RadioProps): JSX.Element => {
    const { label, setValue, value, ...rest } = props;
    const [field] = useField(rest);

    const checked = field.value === value;
    return (
        <label className={`rmxo-radio-wrapper ${checked ? "rmxo-radio-wrapper-checked" : ""}`}>
            <span className={`rmxo-radio-item ${checked ? "rmxo-radio-item-checked" : ""}`}>
                <input
                    type="radio"
                    {...field}
                    name={props.name}
                    className="ant-radio-button-input"
                    checked={checked}
                    value={value}
                    onChange={(): void => {
                        if (checked) {
                            setValue(props.name, null);
                        } else {
                            setValue(props.name, value);
                        }
                    }}
                />
            </span>
            <span>{label}</span>
        </label>
    );
};

export default Radio;
